module.exports = __webpack_public_path__ + "img/om.f89a97c1.png";